import type { Auth0Client, Auth0ClientOptions } from "@auth0/auth0-spa-js";
import { createAuth0Client } from "@auth0/auth0-spa-js";

import type { Auth0ConfigsPayload } from "./types";

const Auth0Configs = (): Auth0ConfigsPayload => {
  const scope = "profile email";

  const auth0Config = {
    domain: import.meta.env.VITE_AUTH0_DOMAIN ?? "flowls-beta.us.auth0.com",
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? "PEZVr7r1fQErMz50PRP2yaJhe89LbWiK",
    audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? "https://flowls-beta.us.auth0.com/api/v2/",
  };

  return { auth0Config, scope };
};

const { auth0Config, scope } = Auth0Configs();

export const auth0Options: Auth0ClientOptions = {
  authorizationParams: { redirect_uri: window.location.origin, audience: auth0Config.audience, scope },
  cacheLocation: "localstorage",
  clientId: auth0Config.clientId,
  domain: auth0Config.domain,
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
};

export const getAuth0Client = async (): Promise<Auth0Client> => {
  try {
    const client = await createAuth0Client(auth0Options);

    return client;
  } catch {
    throw new Error("getAuth0Client Error");
  }
};

export const getIdToken = async (options?: { forceRefresh?: boolean }): Promise<string | undefined> => {
  try {
    const client = await getAuth0Client();

    const detailedResponse = await client.getTokenSilently({
      authorizationParams: { audience: auth0Config.audience, scope },
      cacheMode: options?.forceRefresh ? "off" : "on",
      detailedResponse: true,
    });

    return `Bearer ${detailedResponse.id_token}`;
  } catch (error) {
    console.error(error);

    return undefined;
  }
};

export const logout = async (): Promise<void> => {
  const client = await getAuth0Client();

  await client.logout({ logoutParams: { returnTo: window.location.origin } });
};

export default Auth0Configs;
